"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteResolver = void 0;
var site_1 = require("@sitecore-jss/sitecore-jss/site");
Object.defineProperty(exports, "SiteResolver", { enumerable: true, get: function () { return site_1.SiteResolver; } });
